import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/.eu';
import Kr from '@di-shared/features/history/.kr';
import {HistoryTab} from '@di-shared/pages/[vin]/history';

export interface HistoryProps {
  vin: string;
  tab: string;
  month: string;

  changeTab(tabType: HistoryTab): void;

  changeMonth(date: Date): void;
}

export default function History({vin, tab, changeTab, month, changeMonth}: HistoryProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          tab={tab}
          changeTab={changeTab}
          month={month}
          changeMonth={changeMonth}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          tab={tab}
          changeTab={changeTab}
          month={month}
          changeMonth={changeMonth}
        />
      </Environment.Kr>
    </>
  );
}
